import { ReferenceInput, AutocompleteInput, required } from "react-admin";
import { Grid } from "@mui/material";
import { useWatch } from "react-hook-form";
import { administrationRequests } from "api/administrationApi";

export const BuildingOrUniversityInput = () => {
  const buildingId = useWatch({ name: "contact.buildingId" });
  const universityId = useWatch({ name: "contact.universityId" });
  return (
    <>
      <Grid
        item
        xs={12}
        md={4}
      >
        <ReferenceInput
          source="contact.buildingId"
          reference={administrationRequests.getBuildingsSelect()}
          label="Сграда"
        >
          <AutocompleteInput
            label="Сграда"
            optionText="name"
            optionValue="id"
            filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
            disabled={!!universityId}
            validate={universityId ? "" : required()}
          />
        </ReferenceInput>
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <ReferenceInput
          source="contact.universityId"
          reference={administrationRequests.getUniversitiesSelect()}
          label="Университет"
        >
          <AutocompleteInput
            label="Университет"
            optionText="name"
            optionValue="id"
            filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
            disabled={!!buildingId}
            validate={buildingId ? "" : required()}
          />
        </ReferenceInput>
      </Grid>
    </>
  );
};
